import { useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { readRemembered, writeRemembered } from '../../../shared/lib/remembered';

const REMEMBERED_KEY = 'stats:account';

/**
 * Аккаунт, выбранный в «Статистике» (выгрузки, история сборов): `?account=`
 * из адреса, иначе последний выбранный в этом браузере. Раньше аккаунт
 * приходилось выбирать заново на каждом заходе.
 */
export function useStatsAccount(): [string, (id: string) => void] {
  const [params, setParams] = useSearchParams();
  const fromUrl = params.get('account');
  const value = fromUrl ?? readRemembered<string>(REMEMBERED_KEY, '');

  // Пришли по ссылке с аккаунтом — он и становится «последним».
  useEffect(() => {
    if (fromUrl) writeRemembered(REMEMBERED_KEY, fromUrl);
  }, [fromUrl]);

  const set = useCallback(
    (id: string) => {
      writeRemembered(REMEMBERED_KEY, id || null);
      setParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          if (id) next.set('account', id);
          else next.delete('account');
          return next;
        },
        { replace: true },
      );
    },
    [setParams],
  );

  return [value, set];
}

